import React from 'react';
import { useFormContext } from 'react-hook-form';

import { VpHookFormInput } from '../../inputs';

export const PasswordConfirmInput = () => {
  const { watch } = useFormContext();
  const passwordValue = watch('password');
  const rules = {
    validate: {
      confirm: (value) => value === passwordValue || 'Password values must match'
    }
  };
  return (
    <VpHookFormInput
      maxLength={100}
      required
      name="passwordConfirm"
      type="password"
      rules={rules}
      placeholder="Confirm Password"
    />
  );
};

export default PasswordConfirmInput;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/sign-up/PasswordConfirmInput.jsx